const IDistrictService = require('../IDistrictService');
const DistrictConsts = require('./common/DistrictConsts');
const Util = require('./common/Util');
const g2 = require('../../../g2');
/**
 * @classdesc 资源分析服务
 * @alias G.servicev2.DistrictServiceImpl
 * @augments G.service.IDistrictService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class DistrictServiceImpl extends IDistrictService {
    constructor(opts) {
        super(opts);
        //
    }

    /**
     * @inheritdoc
     * @param {*} opts 
     */
    getDistrict(opts) {
        return new Promise(async(resolve, reject) => {
            var districtCodeArr = opts.code,
                districtCode = districtCodeArr[0];
            var query = {};
            var data = {};
            data.query = query;
            data.limit = 10000;
            if (districtCode !== '000000') {
                query['tag.adcode'] = {
                    '$in': districtCodeArr
                }
            }
            if(opts.returnGeom === false){
                data.select = '-geom';
            }
            let levelObj = this._getDistrictLevel(districtCode);
            let table = this._getDistrictTableName(levelObj.level);
            let result = await Util.query({
                url: this.opts.url,
                httpRequest: this.opts.httpRequest,
                table: table,
                data: data,
                eId: 'siptea',
                dataParser: this._dataParser
            });
            resolve(result);
        });
    }

    //
    _getDistrictLevel(districtCode) {
        let levelObj = {
            parent: null,
            level: null,
            child: null
        };
        if (districtCode == '000000') {
            levelObj.level = 'country';
            levelObj.child = 'province';
            query = '';
        } else if (districtCode.endsWith('0000')) {
            levelObj.parent = 'country';
            levelObj.level = 'province';
            levelObj.child = 'city';
        } else if (districtCode.endsWith('00')) {
            levelObj.parent = 'province';
            levelObj.level = 'city';
            levelObj.child = 'county';
        } else {
            levelObj.parent = 'city';
            levelObj.level = 'county';
        }
        return levelObj;
    }

    /**
     * @private
     * @param {*} level 
     * @param {*} evacuationIndex 
     * @param {*} fullName 
     */
    _getDistrictTableName(level, evacuationIndex, fullName) {
        var districtTables = DistrictConsts.DISTRICTTABLES,
            tableCfg = districtTables[level],
            tableName;
        if (tableCfg) {
            tableName = fullName ? tableCfg.fullName : tableCfg.shortName;
            if (tableCfg.evacuationParams && tableCfg.evacuationParams.length > 0) {
                evacuationIndex = isNaN(evacuationIndex) ? 0 : evacuationIndex;
                tableName += tableCfg.evacuationParams[evacuationIndex];
            }
        }
        return tableName;
    }

    //
    _dataParser(data) {
        let list = data.list;
        let resultList = [];
        for (let i = 0; i < list.length; i++) {
            let item = list[i];
            let obj = {};
            obj.name = item.name;
            obj.code = item.adcode;
            if (item.gov) {
                let xy = item.gov.split(',');
                obj.lng = parseFloat(xy[0]);
                obj.lat = parseFloat(xy[1]);
            }
            obj.geom = item.geom;
            resultList.push(obj);
        }
        return resultList;
    }

    /**
     * 获取下级行政区划列表
     * @inheritdoc
     */
    getSubDistrict(opts) {
        return new Promise(async(resolve, reject) => {
            let districtCode = opts.code;
            let levelObj = this._getDistrictLevel(districtCode);
            let queryLevel = levelObj.child;
            let regexStr = '';
            if (DistrictConsts.DIRECTCITYS.hasOwnProperty(districtCode)) {
                queryLevel = 'county';
                regexStr = '^' + districtCode.substr(0, 2) + '.*$';
            } else {
                switch (queryLevel) {
                    case 'province':
                        {
                            regexStr = '^.*$';
                            break;
                        }
                    case 'city':
                        {
                            regexStr = '^' + districtCode.substr(0, 2) + '.*$';
                            break;
                        }
                    case 'county':
                        {
                            regexStr = '^' + districtCode.substr(0, 4) + '.*$';
                            break;
                        }
                }
            }
            let table = this._getDistrictTableName(queryLevel);
            let query = {};
            query['tag.adcode'] = {
                '$regex': regexStr
            }
            let result = await Util.query({
                url: this.opts.url,
                httpRequest: this.opts.httpRequest,
                table: table,
                data: {
                    query: query,
                    limit: 10000
                },
                eId: 'siptea',
                dataParser: this._dataParser
            });
            resolve(result);
        });
    }

    /**
     * 根据经纬度获取行政区划信息
     * @inheritdoc
     */
    getDistrictByPoint(opts){
        return this.getDistrictByLngLat(opts);
    }
    /**
     * 根据经纬度获取行政区划信息
     * @ignore
     */
    getDistrictByLngLat(opts) {
        return new Promise(async(resolve, reject) => {
            let geom = {
                type: 'Point',
                coordinates: opts.point
            }
            if (opts.spatialReference && opts.spatialReference != 4326) {
                let projectService = new g2.sfs.CoordinateTransform();
                let geom = new g2.sfs.Point({
                    x: opts.point[0],
                    y: opts.point[1],
                    spatialReference: opts.spatialReference
                });
                let transformGeom = projectService.transform(geom, 4326);
                geom = transformGeom.asGeoJson();
            }
            let aggregateObj = {};
            aggregateObj.query = {
                "geom": {
                    "$geoIntersects": {
                        "$geometry": geom
                    }
                }
            };
            aggregateObj.searchId = 'districtbylnglat';
            aggregateObj.dataSetId = this._getDistrictTableName('county');
            aggregateObj.queryIndex = 0;
            let aggregate = [];
            aggregate.push({
                "$project": {
                    "tag": "$tag",
                    "city": {
                        "$concat": [{
                                $substr: ["$tag.adcode", 0, 4]
                            },
                            "00"
                        ]
                    },
                    "province": {
                        "$concat": [{
                                $substr: ["$tag.adcode", 0, 2]
                            },
                            "0000"
                        ]
                    }
                }
            });
            aggregate.push({
                $lookup: {
                    "from": this._getDistrictTableName('city', 0, true),
                    "localField": "city",
                    "foreignField": "tag.adcode",
                    "as": "city"
                }
            });
            aggregate.push({
                $lookup: {
                    "from": this._getDistrictTableName('province', 0, true),
                    "localField": "province",
                    "foreignField": "tag.adcode",
                    "as": "province"
                }
            });
            aggregate.push({
                $project: {
                    "tag": "$tag",
                    "city": "$city.tag",
                    "province": "$province.tag"
                }
            });
            aggregateObj.aggregate = aggregate;
            let result = await Util.aggregateMulti({
                eId: 'siptea',
                httpRequest: this.opts.httpRequest,
                url: this.opts.url,
                aggregateList: [aggregateObj],
                dataParser: (result) => {
                    let data = null;
                    let list = result[aggregateObj.searchId][aggregateObj.dataSetId];
                    if (list.length == 1) {
                        let item = list[0];
                        data = {};
                        data.county = {
                            name: item.tag.name,
                            code: item.tag.adcode
                        }
                        if (item.city && item.city.length == 1) {
                            data.city = {
                                name: item.city[0].name,
                                code: item.city[0].adcode
                            }
                        }
                        if (item.province && item.province.length == 1) {
                            data.province = {
                                name: item.province[0].name,
                                code: item.province[0].adcode
                            }
                        }
                    }
                    return data;
                }
            });
            resolve(result);
        });
    }
}

module.exports = DistrictServiceImpl;